export default __webpack_public_path__ + "static/media/my.c6867e8d.svg";